<template>
    <div class="query-settings">
        <!-- <div class="page-setting dfc mb20">
      <p class="setting-title">查询端口：</p>
      <el-radio-group v-model="portValue" disabled @change="radioChange(1)">
        <el-radio v-for="(item, index) in port" :key="index" :label="index">{{
          item
        }}</el-radio>
      </el-radio-group>
    </div> -->
        <div v-show="portValue === 1" class="page-setting dfc mb20">
            <p class="setting-title">查询页数：</p>
            <el-radio-group v-model="portPagesValue" @change="radioChange(2)">
                <el-radio v-for="(item, index) in portPages" :key="index" :label="index">{{ item }}个</el-radio>
            </el-radio-group>
        </div>
        <div v-show="portValue === 0" class="page-setting dfc mb20">
            <p class="setting-title">查询页数：</p>
            <el-radio-group v-model="pageValue" @change="radioChange(3)">
                <el-radio v-for="(item, index) in pages" :key="index" :label="index">{{ item }}页</el-radio>
            </el-radio-group>
        </div>
        <slot></slot>
        <div class="keywords-setting mt20 dfc">
            <p class="setting-title">查询关键词：</p>
            <div style="position: relative">
                <el-popover placement="bottom-start" width="446" trigger="click" :disabled="records.length === 0">
                    <div class="record-keyword">
                        <p class="record-keyword-title">最近搜索</p>
                        <div class="dfc" style="flex-wrap: wrap">
                            <div
                                v-for="(item, index) in records"
                                :key="index"
                                class="record-keyword-item"
                                @click="selectKeyword(item)"
                            >
                                <p>{{ item }}</p>
                                <i class="del" @click.stop="delKeyword(item, index)">×</i>
                            </div>
                        </div>
                    </div>
                    <el-input
                        slot="reference"
                        v-model="keyword"
                        type="textarea"
                        style="width: 350px"
                        :rows="5"
                        placeholder="请输入内容"
                        resize="none"
                        @change="handleKeyword"
                    />
                </el-popover>
                <p>{{ keywordArr.length }}/5</p>
            </div>
            <el-button type="primary" size="medium" style="margin-left: 10px; width: 126px" @click="rankingQuery"
                >排名查询</el-button
            >
        </div>
        <div class="tips mt20 dfc">
            <div class="title">
                <i class="iconfont-npm icon-npm-gantan skyFont"></i><span class="ml3">特别提示：</span>
            </div>
            <div class="tips-content">
                <p>
                    1、排名查询功能受1688官方影响，短时间内频繁查询可能会被屏蔽IP，如出现屏蔽提示，请休息一段时间后重新登录操作。
                </p>
                <p>2、排名查询结果受千人千面及电脑缓存影响，可能存在小误差，但不影响运营数据分析和参考。</p>
                <p>3、若排名查询的关键字较多，且查询的页数是1-200个，则需较长时间，建议分批查询。</p>
            </div>
        </div>
    </div>
</template>
<script>
import { cloneDeep } from 'lodash';
export default {
    name: 'QuerySettings',
    props: {
        restNum: {
            type: [String, Number],
            require: true,
        },
        queryType: {
            type: Number,
        },
    },
    data() {
        return {
            port: ['PC端', '移动端'],
            portValue: 1,
            portPages: ['1-120', '1-200'], // 移动端查询范围
            portPagesValue: 0,
            pages: ['1-3', '1-10', '11-20', '21-30'], // PC端查询范围
            pageValue: 0,
            keyword: '',
            keywordArr: [],
            records: [],
            limitNum: 5, // 限制关键词个数
        };
    },
    mounted() {
        this.$ajax.post('app/ca/getkw', { pageIndex: 1, pageSize: 20 }).then((res) => {
            if (res.success) {
                this.records = res.data;
            }
        });
        this.radioChange();
    },
    methods: {
        selectKeyword(val) {
            if (this.keywordArr.length > this.limitNum) {
                return;
            }
            this.keyword += (this.keyword ? '\n' : '') + val.trim();
            this.handleKeyword();
        },
        delKeyword(val, index) {
            this.$ajax
                .post('app/ca/delkw', {
                    keyword: val,
                })
                .then((res) => {
                    if (!res.Success) {
                        this.$message.warning('删除失败');
                        return;
                    }
                    this.$message.success('删除成功');
                    this.records.splice(index, 1);
                });
        },
        rankingQuery() {
            const tempArr = ['全店产品', '单产品', '关键词'];
            judgeDazeCollector({
                name: '排名查询',
                operate: `${tempArr[this.queryType]}排名查询排名查询`,
                tag: '',
                value: '',
            });
            const len = this.keywordArr.length;
            if (this.keyword === '' || len === 0) {
                this.$message.warning('请填写查询关键词！');
                return;
            }
            if (len > this.limitNum) {
                this.$message.warning(`查询关键词超过${this.limitNum}个！`);
                return;
            }
            if (this.restNum === 0) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: `今日关键词查询数量仅剩 <em style='color: red;'>0</em> 个，请明天再来查询`,
                    type: 'warning',
                });
                return;
            }
            if (len > this.restNum) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: `今日关键词查询数量仅剩 <em style='color: red;'>${this.restNum}</em> 个，请减少本次关键词查询个数`,
                    type: 'warning',
                });
                return;
            }
            this.$emit('search', cloneDeep(this.keywordArr), this.portPagesValue);
        },
        handleKeyword() {
            let arr = this.keyword
                .split('\n')
                .filter(function (k) {
                    return !!k; // 有值的
                })
                .map(function (v) {
                    return v.trim(); // 去除左右空格
                });
            arr = [...new Set(arr)]; // 去重
            if (arr.length > this.limitNum) {
                arr.length = this.limitNum;
            }
            this.keyword = arr.reduce((str, o) => str + (str ? '\n' : '') + o.trim(), '');
            this.keywordArr = arr;
        },
        radioChange(val) {
            const tempArr = ['全店产品', '单产品', '关键词'];
            const port = this.portValue;
            const pages = port === 0 ? this.pages[this.pageValue] : this.portPages[this.portPagesValue];
            if (val) {
                if (val === 1) {
                    // pc端和移动端
                    judgeDazeCollector({
                        name: '排名查询',
                        operate: `${tempArr[this.queryType]}排名查询${port === 0 ? 'PC端' : '移动端'}`,
                        tag: '',
                        value: '',
                    });
                } else if (val === 3 && this.queryType === 0) {
                    judgeDazeCollector({
                        name: '排名查询',
                        operate: `全店产品排名查询${pages}页`,
                        tag: '',
                        value: '',
                    });
                }
            }
            this.$emit('getPageRange', { port, pages });
        },
    },
};
</script>

<style lang="scss" scoped>
.query-settings {
    padding: 25px 20px;
    background: #fff;
    font-size: 14px;
    line-height: 1.5em;
    .setting-title {
        width: 100px;
        text-align: right;
    }
    .keywords-setting {
        align-items: flex-start;
    }
    .tips {
        color: #999;
        font-size: 12px;
        align-items: flex-start;
        .title {
            text-align: right;
            width: 100px;
            i {
                font-size: 12px;
            }
        }
    }
}
.record-keyword {
    font-size: 12px;
    font-family: SimSun;
    .record-keyword-title {
        line-height: 1;
        margin: 10px 0;
        padding-left: 16px;
        background: url($domain + 'dz-npm-package/images/competingAnalysis/competing.png') -103px -201px no-repeat;
    }
    .record-keyword-item {
        padding: 0 10px;
        line-height: 28px;
        height: 28px;
        border: 1px solid #d9d9d9;
        color: #999;
        margin: 0 10px 10px 0;
        position: relative;
        vertical-align: middle;
        max-width: 137px;
        cursor: pointer;
        position: relative;
        p {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .del {
            font-size: 12px;
            display: none;
            position: absolute;
            height: 14px;
            width: 14px;
            border: 1px solid #eee;
            z-index: 10;
            line-height: 14px;
            text-align: center;
            right: -7px;
            top: -7px;
            color: #666;
            border-radius: 50%;
            background: #fff;
            box-shadow: 0 0 5px #ccc;
        }
        &:hover {
            color: #ff9000;
            border: 1px solid #ff9000;
            .del {
                display: block;
            }
        }
    }
}
</style>
